export default {
  title: "Search invoices",

  input: {
    status: "Status",
    invoiceNumber: "Invoice number",
    target: "Name",
    type: "Type",
  },
}
